var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-data-table", attrs: { id: "employee-table" } },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _c("div", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("ADMINISTRATOR")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex m__t--45" },
            [
              _vm._l(_vm.tabMenu, function(tab, index) {
                return [
                  tab.show
                    ? _c(
                        "div",
                        {
                          key: tab.label,
                          class: [
                            { "m__r--35": index < _vm.tabMenu.length - 1 },
                            tab.active
                              ? "tab-experience-manager-active"
                              : "tab-experience-manager"
                          ],
                          on: {
                            click: function($event) {
                              _vm.$router.replace(tab.url)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(tab.label) + "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-administrator-content" },
        [
          _c(
            "v-server-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.load_first,
                  expression: "load_first"
                }
              ],
              ref: "employeeServer",
              staticClass: "jTable studio-table",
              attrs: { columns: _vm.columns, options: _vm.options },
              on: {
                loading: _vm.loading,
                loaded: _vm.loaded,
                "row-click": _vm.rowClick
              },
              scopedSlots: _vm._u([
                {
                  key: "staff_name",
                  fn: function(props) {
                    return _c("div", {}, [
                      props.row.profile
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "td" },
                              [
                                props.row.profile.photo_url
                                  ? _c("b-img", {
                                      staticClass:
                                        "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                      attrs: {
                                        src: props.row.profile.photo_url,
                                        rounded: "circle",
                                        alt: "img"
                                      }
                                    })
                                  : _c("b-img", {
                                      staticClass:
                                        "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                      attrs: {
                                        src: require("../../assets/logo/user1.png"),
                                        rounded: "circle",
                                        alt: "img"
                                      }
                                    })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "td p__t--7" }, [
                              _c("div", [_vm._v(_vm._s(props.row.email))]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(props.row.profile.first_name) +
                                    " " +
                                    _vm._s(props.row.profile.last_name)
                                )
                              ])
                            ])
                          ])
                        : _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.row.email) +
                                "\n        "
                            )
                          ])
                    ])
                  }
                },
                {
                  key: "user_id",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            props.row.profile && props.row.profile.user_id
                              ? props.row.profile.user_id
                              : "-"
                          ) +
                          "\n      "
                      )
                    ])
                  }
                },
                {
                  key: "user_company_id",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            props.row.profile &&
                              props.row.profile.user_company_id
                              ? props.row.profile.user_company_id
                              : "-"
                          ) +
                          "\n      "
                      )
                    ])
                  }
                },
                {
                  key: "role",
                  fn: function(props) {
                    return _c("div", { staticStyle: { width: "150px" } }, [
                      props.row.profile
                        ? _c("div", [
                            props.row.profile.user_role
                              ? _c("span", { staticClass: "roles-text" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.convertRole(
                                          props.row.profile.user_role
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  }
                },
                {
                  key: "is_active",
                  fn: function(props) {
                    return _c("div", {}, [
                      _c(
                        "div",
                        {
                          staticClass: "status-user",
                          class: props.row.is_active
                            ? "status-on"
                            : "status-off"
                        },
                        [
                          _c("div", { staticClass: "circle-accent" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(props.row.is_active ? "ON" : "OFF"))
                          ])
                        ]
                      )
                    ])
                  }
                },
                {
                  key: "created_date",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("moment")(
                              props.row.created_date,
                              "YYYY-MM-DD hh:mm:ss"
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  }
                },
                {
                  key: "updated_date",
                  fn: function(props) {
                    return _c("div", {}, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("moment")(
                              props.row.updated_date,
                              "YYYY-MM-DD hh:mm:ss"
                            )
                          ) +
                          "\n      "
                      )
                    ])
                  }
                }
              ])
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-search",
                  attrs: { slot: "beforeFilter" },
                  slot: "beforeFilter"
                },
                [
                  _c(
                    "b-form",
                    { attrs: { inline: "" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn grey btn-import-oos m__r--5",
                          on: {
                            click: function($event) {
                              _vm.$router.replace("/administrator/create")
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-lg" }),
                          _vm._v(" Add\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form",
                        {
                          attrs: { inline: "" },
                          on: {
                            keypress: function($event) {
                              if (
                                !("button" in $event) &&
                                $event.keyCode !== 13
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.filter(_vm.filter_data)
                            }
                          }
                        },
                        [
                          _c("j-select", {
                            staticClass: "m__r--5",
                            attrs: {
                              options: _vm.options_search,
                              "error-required": false,
                              placeholder: "Filter By"
                            },
                            model: {
                              value: _vm.select_type,
                              callback: function($$v) {
                                _vm.select_type = $$v
                              },
                              expression: "select_type"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "filterInput",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", [!_vm.load_first ? _c("jLoadingTable") : _vm._e()], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "searchFormModal",
          attrs: {
            show: _vm.popoverSearchShow,
            triggers: "click",
            container: "employee-table",
            target: "table-search",
            placement: "right"
          },
          on: {
            "update:show": function($event) {
              _vm.popoverSearchShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "m__b--10" }, [_vm._v("Search Data")]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              attrs: { inline: "" },
              on: {
                keypress: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  $event.preventDefault()
                  _vm.filter(_vm.filter_data)
                }
              }
            },
            [
              _c("j-select", {
                staticClass: "m__r--5",
                attrs: { disabled: false, options: _vm.options_search },
                model: {
                  value: _vm.select_type,
                  callback: function($$v) {
                    _vm.select_type = $$v
                  },
                  expression: "select_type"
                }
              }),
              _vm._v(" "),
              _c("j-input", {
                staticClass: "m__r--5",
                attrs: { placeholder: "Search" },
                model: {
                  value: _vm.filter_data,
                  callback: function($$v) {
                    _vm.filter_data = $$v
                  },
                  expression: "filter_data"
                }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue outline",
                  staticStyle: { "margin-top": "-19px" },
                  on: {
                    click: function($event) {
                      _vm.filter(_vm.filter_data)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search bold" }),
                  _vm._v(" Search\n      ")
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c9ec626", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c9ec626","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/jEmployeeList.vue
// module id = null
// module chunks = 